export default "__VITE_ASSET__671dddc5__"